import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f9fafb",
        padding: "24px",
      }}
    >
      <div
        style={{
          maxWidth: 480,
          textAlign: "center",
          background: "#fff",
          padding: "40px 32px",
          borderRadius: 12,
          boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
        }}
      >
        <h1 style={{ fontSize: 72, marginBottom: 8, color: "#111827" }}>
          404
        </h1>

        <h2 style={{ fontSize: 20, marginBottom: 12, color: "#1f2937" }}>
          Page not found
        </h2>

        <p style={{ color: "#6b7280", marginBottom: 24 }}>
          The page you’re looking for doesn’t exist or may have been moved.
        </p>

        <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
          <button
            className="btn btn-primary"
            onClick={() => navigate("/index")}
          >
            Go to Dashboard
          </button>

          {/* <button
            className="btn btn-outline-secondary"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
